/** Strings owned by `src/manage/overview/` — "Beheer › Overzicht"
 * (PLAN-FASE3.md WP-05): the platform-staff-only KPI overview. No NPS or
 * AI-summary card — out of scope, see AdminOverviewPage.tsx. */
export const manageOverview = {
  page: {
    title: 'Overview',
    lead: 'Platform-wide key figures: revenue, active companies and users, and retention.',
    activeCompanies: 'Active companies',
    activeUsers: 'Active users',
    revenueThisMonth: 'Revenue this month',
    retention: 'Retention (month over month)',
    retentionUnavailable: 'No data yet',
    retentionDetail: '{{retained}} of {{total}} companies retained',
  },
} as const;
